import * as Sentry from '@sentry/react';

import { NODE_ENV, SENTRY_DNS } from './config-global';

export default function initSentry() {
  Sentry.init({
    dsn: SENTRY_DNS,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: NODE_ENV
  });
}
